/**
 * Project : workspace
 * File    : InventoryNavRoute.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.route.inventory

import navigation.route.inventory.brand.InventoryBrandNavRoute
import navigation.route.inventory.color.InventoryColorNavRoute
import navigation.route.inventory.coupon.InventoryCouponNavRoute
import navigation.route.inventory.discount.InventoryDiscountNavRoute
import navigation.route.inventory.product.ProductNavRoute
import navigation.route.inventory.productCategory.ProductCategoryNavRoute
import navigation.route.inventory.productSubCategory.ProductSubCategoryNavRoute
import navigation.route.inventory.size.InventorySizeNavRoute
import navigation.route.inventory.tag.InventoryTagNavRoute
import navigation.route.inventory.uom.InventoryUOMNavRoute

/**
 * Represents the inventory nav route class.
 */

class InventoryNavRoute {
    companion object{
        const val ROOT = "inventory/"
        const val HOME = "${ROOT}home"
        val Product = ProductNavRoute
        val ProductCategory = ProductCategoryNavRoute
        val ProductSubCategory = ProductSubCategoryNavRoute
        val UOM = InventoryUOMNavRoute
        val Tag = InventoryTagNavRoute
        val Size = InventorySizeNavRoute
        val Brand = InventoryBrandNavRoute
        val Color = InventoryColorNavRoute
        val Coupon = InventoryCouponNavRoute
        val Discount = InventoryDiscountNavRoute
        const val PRODUCTS = "${ROOT}products"
        const val LIST = "${ROOT}list"
        const val DETAILS = "${ROOT}details"
        const val CREATE = "${ROOT}create"
        const val UPDATE = "${ROOT}update"
        const val SELECT = "${ROOT}select"
    }
}